export { useShallowSelector } from '../../../hooks/useShallowSelector';

export const componentSelector = (state) => ({
  activeAdvanceId: state.activeIds.advanceId,
  advances: state.entities.advances,
  loanForgiveness: state.entities.loanForgiveness,
});
